import { Box, Button } from "@mui/material";
import { ApiType, apiTypeDocsMap } from ".";
import { ApiInfo } from "./ApiInfo";
import ApiRoundedIcon from "@mui/icons-material/ApiRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import InfoIcon from "@mui/icons-material/Info";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
type Props = {
  type: ApiType;
};
const viewEndpointApiTypes: ApiType[] = ["quick-access", "backend-coding", "graphql", "site-generators"];
const learnMoreEndpointApiTypes: ApiType[] = ["custom-endpoints", "visual-layout"];
export const ApiCard = ({
  type
}: Props) => {
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  return <Box width="100%"
  // minHeight="378px"
  p={2} borderRadius="8px" display="flex" gap={1.5} flexDirection="column" justifyContent="space-between" sx={{
    border: (theme: any) => `1px solid ${theme.palette.border}`
  }} bgcolor="common.white" data-sentry-element="Box" data-sentry-component="ApiCard" data-sentry-source-file="ApiCard.tsx">
      <ApiInfo type={type} data-sentry-element="ApiInfo" data-sentry-source-file="ApiCard.tsx" />
      <Box display="flex" gap={1.5} data-sentry-element="Box" data-sentry-source-file="ApiCard.tsx">
        {viewEndpointApiTypes.includes(type) && <Button size="small" variant="outlined" startIcon={<ApiRoundedIcon />} onClick={() => history.push(`${location.pathname}/${type}`)} sx={{
        flex: 1
      }}>
            {t("schema.viewEndpoints")}
          </Button>}
        {learnMoreEndpointApiTypes.includes(type) && <Button size="small" variant="outlined" startIcon={<InfoIcon />} onClick={() => history.push(`${location.pathname}/${type}`)} sx={{
        flex: 1
      }}>
            {t("schema.learnMore")}
          </Button>}
        <Button size="small" color="inherit" variant="outlined" startIcon={<MenuBookRoundedIcon color="action" />} onClick={() => window.open(apiTypeDocsMap[type])} sx={{
        flex: 1
      }} data-sentry-element="Button" data-sentry-source-file="ApiCard.tsx">
          {t("shell.docs")}
        </Button>
      </Box>
    </Box>;
};